import { defineMessage } from "react-intl";
import { IoPlayOutline, IoPauseOutline } from "react-icons/io5";

export const COUNTRIES_STATE_VALUE_ENABLED = "enabled";
export const COUNTRIES_STATE_VALUE_DISABLED = "disabled";

export const COUNTRIES_STATES = {
  [COUNTRIES_STATE_VALUE_ENABLED]: {
    id: COUNTRIES_STATE_VALUE_ENABLED,
    colors: ["green.600", "green.300"],
    color: "green",
    icon: IoPlayOutline,
  },
  [COUNTRIES_STATE_VALUE_DISABLED]: {
    id: COUNTRIES_STATE_VALUE_DISABLED,
    colors: ["purple.600", "purple.300"],
    color: "purple",
    icon: IoPauseOutline,
  },
};

export const COUNTRIES_STATE_LIST = Object.values(COUNTRIES_STATES);

export const COUNTRIES_STATE_MESSAGE = defineMessage({
  defaultMessage:
    "{state, select, enabled {activé} disabled {désactivé} other {state}}",
});

export const COUNTRIES_STATE_VERB_MESSAGE = defineMessage({
  defaultMessage:
    "{state, select, enabled {activer} disabled {désactiver} other {state}}",
});

// ============================================================

export const COUNTRIES_SORT_VALUE_NAME_ASC = "name_asc";
export const COUNTRIES_SORT_VALUE_NAME_DESC = "name_desc";

export const COUNTRIES_SORTS = {
  [COUNTRIES_SORT_VALUE_NAME_ASC]: {
    id: COUNTRIES_SORT_VALUE_NAME_ASC,
  },
  [COUNTRIES_SORT_VALUE_NAME_DESC]: {
    id: COUNTRIES_SORT_VALUE_NAME_DESC,
  },
};

export const COUNTRIES_SORT_LIST = Object.values(COUNTRIES_SORTS);

export const COUNTRIES_SORT_MESSAGE = defineMessage({
  defaultMessage:
    "{sort, select, name_asc {A ⇨ Z} name_desc {Z ⇨ A} other {{sort}}}",
});
